<template>
  <div>
    <div class="kit__utils__heading">
      <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="row justify-content-between">
          <div class="col-6 col-lg-4 col-md-4 col-sm-3" v-for="item in getBankSum" :key="item.bankServiceId">
            <div class="row justify-content-between" style="border:1px solid ;border-radius: 5px;">
              <div class="col-12 col-lg-4 col-sm-12 p-4">
                <a-card hoverable style="width: 100%;">
                  <img slot="cover" alt="example" :src="PreviewImg(item.icon)" />
                </a-card>
              </div>
              <div class="col-12 col-lg-8 col-sm-12 p-2 mt-1">
                <label>{{(item.longName !== '')?item.longName:'ไม่พบข้อมูล'}}({{(item.short !== '')?item.short:'ไม่พบข้อมูล'}})</label><br>
                <label>ชื่อบัญชี : {{(item.accountName !== '')?item.accountName:'ไม่พบข้อมูล'}}</label><br>
                <label>เลขที่บัญชี : {{(item.accountNumber !== '')?item.accountNumber:'ไม่พบข้อมูล'}}</label><br>
                <label>จำนวนเงิน :
                  {{(item.amountSum > 0)?item.amountSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','):0}}</label><br>
                <label>เครดิต : {{(item.balance > 0)?item.balance:0}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 col-sm-12 p-4">
        <a class="btn btn-primary" href="javascript: void(0);" @click="getDataRefund()"><i
          class="fe fe-arrow-up-right mr-1" /> สร้างรายการคืนเงินลูกค้า</a>
      </div>
      <div class="card-header card-header-flex">
        <search v-bind="sentDataSearch"></search>
      </div>
      <div class="card-body">
        <tableRefund @isReload-table="isReloadTable" @isReload-data="isReloadData" v-bind="sendDataTable" />
      </div>
    </div>

    <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" layout="vertical">
            <div class="row">
                <div class="col-md-12">
                    <a-form-model-item label="คู่ค้า" prop="operator">
                        <a-select
                            v-model="form.operator"
                            show-search
                            placeholder="กรุณาเลือกข้อมูล"
                            style="width: 100%"
                            @select="setOperator"
                        >
                            <a-select-option value="">
                                กรุณาเลือกข้อมูล
                            </a-select-option>
                            <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="บัญชีธนาคารลูกค้า" prop="userBank">
                        <a-select
                            v-model="form.userBank"
                            show-search
                            placeholder="กรุณาเลือกข้อมูล"
                            style="width: 100%"
                            :disabled="(getUserBank)?false:true"
                            @select="setUserBank"
                        >
                            <a-select-option value="">
                                กรุณาเลือกข้อมูล
                            </a-select-option>
                            <a-select-option
                                v-for="(item , index) in getUserBank" :key="index" :value="item.userBankName">
                                {{ item.userBankName }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="บัญชีระบบ" prop="bankservice">
                        <a-select
                            v-model="form.bankservice"
                            show-search
                            placeholder="กรุณาเลือกข้อมูล"
                            style="width: 100%"
                            :disabled="(getBankService)?false:true"
                            @select="setBankService"
                        >
                            <a-select-option value="">
                                กรุณาเลือกข้อมูล
                            </a-select-option>
                            <a-select-option
                                v-for="(item , index) in getBankService" :key="index" :value="item.bankServiceSystem">
                                {{ item.bankServiceSystem }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="จำนวนเงิน" prop="amount">
                        <a-input-number
                            v-model="form.amount"
                            size="large"
                            style="width: 100%"
                        />
                    </a-form-model-item>
                </div>
            </div>
        </a-form-model>
    </a-modal>
    <a-modal :title="this.formOTP.title" v-model="visibleOTP" ok-text="ยืนยัน" cancel-text="ยกเลิก"  @cancel="modalOTPClose">
          <template slot="footer">
            <a-button key="refund"  @click="resendOTP">
                ส่งอีกครั้ง
            </a-button>
            <a-button key="cancel" type="danger" @click="cancelOTP">
                ยกเลิก
            </a-button>
            <a-button key="submit" type="primary" @click="sentOTP">
                ยืนยัน
            </a-button>
        </template>
        <a-form-model ref="ruleForm" :model="formOTP" :rules="rulesOTP" layout="vertical">
            <a-form-model-item label="OTP" prop="OTPCode">
                <a-input
                    v-model="formOTP.OTPCode"
                    size="large"
                    style="width: 100%"
                />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
    <a-modal title="ตรวจสอบบัญชีธนาคาร" v-model="visibleCheckBank" :confirm-loading="confirmLoading" ok-text="ยืนยัน" cancel-text="ยกเลิก"
      @ok="handleSubmit" @cancel="modalCheckBankClose">
      <a-form-model :model="forms" layout="vertical">
        <div class="align-items-center">
          <a-form-item label="ธนาคาร">
            <a-select v-model="forms.bankId" placeholder="กรุณาเลือกข้อมูล">
              <a-select-option v-for="(item , index) in banks" :key="index" :value="item.id">
                {{ item.bankName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="เลขบัญชี">
            <a-input v-model="forms.accountNumber" />
          </a-form-item>
          <a-form-item label="สเตทเม้นไอดี">
            <a-input v-model="forms.depositPaymentId" />
          </a-form-item>
        </div>
      </a-form-model>
    </a-modal>
    <a-modal :title="this.formRefund.title" v-model="visibleFormRefund" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOkFormRefund" @cancel="handleCancelFormRefund">
        <a-form-model ref="ruleFormRefund" :model="formRefund" :rules="rulesRefund" layout="vertical">
            <div class="row">
                <div class="col-md-12">
                    <a-form-model-item label="ธนาคารลูกค้า" >
                        <a-input
                            v-model="formRefund.bank"
                            size="large"
                            style="width: 100%"
                            disabled
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="เลขบัญชี" >
                        <a-input
                            v-model="formRefund.accountNumber"
                            size="large"
                            style="width: 100%"
                            disabled
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="ชื่อบัญชี" >
                        <a-input
                            v-model="formRefund.accountName"
                            size="large"
                            style="width: 100%"
                            disabled
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="ชื่อบัญชี(EN)" >
                        <a-input
                            v-model="formRefund.accountToDisplayName"
                            disabled
                            size="large"
                            style="width: 100%"
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="คู่ค้า" prop="operator">
                        <a-select
                            v-model="formRefund.operator"
                            show-search
                            placeholder="กรุณาเลือกข้อมูล"
                            style="width: 100%"
                            :disabled="true"
                            @select="setOperatorBank"
                        >
                            <a-select-option value="">
                                กรุณาเลือกข้อมูล
                            </a-select-option>
                            <a-select-option v-for="(item , index) in getOperator" :key="index" :value="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="บัญชีระบบ" >
                        <a-select
                            v-model="formRefund.bankServiceSystem"
                            show-search
                            placeholder="กรุณาเลือกข้อมูล"
                            style="width: 100%"
                            :disabled="(getUserBankRefund)?false:true"
                            @select="setBankServiceRefund"
                        >
                            <a-select-option value="">
                                {{ this.formRefund.bankServiceSystem }}
                            </a-select-option>
                            <!-- <a-select-option
                                v-for="(item , index) in getUserBankRefund" :key="index" :value="item.bankServiceId">
                                {{ item.bankServiceSystem }}
                            </a-select-option> -->
                        </a-select>
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="จำนวนเงิน" prop="amount">
                        <a-input-number
                            v-model="formRefund.amount"
                            size="large"
                            style="width: 100%"
                            :disabled="true"
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="หมายเหตุ" prop="remark">
                        <a-input
                            v-model="formRefund.remark"
                            size="large"
                            style="width: 100%"
                        />
                    </a-form-model-item>
                </div>
                <div class="col-md-12">
                    <a-form-model-item label="สลิปหลักฐาน" prop="slip">
                        <a-input
                            v-model="formRefund.slip"
                            size="large"
                            style="width: 100%"
                        />
                    </a-form-model-item>
                </div>
            </div>
        </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import apiClient from '@/services/api'
import tableRefund from './tableRefund'
import search from '@/components/system/table/search/transection'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  components: {
    search,
    tableRefund,
  },
  data() {
    return {
      pageType: 'withdraw',
      visible: false,
      visibleCheckBank: false,
      visibleFormRefund: false,
      visibleOTP: false,
      reloadTable: false,
      reloadData: false,
      form: {
        title: '',
        operator: '',
        userBank: '',
        bankservice: '',
        amount: '',
        operatorCode: '',
        bankServiceId: '',
        userBankId: '',
      },
      getOperator: [],
      getUserBank: null,
      getBankSum: null,
      getBankService: null,
      getUserBankRefund: null,
      getBankServiceRefund: null,
      rules: {
        operator: [
          { required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' },
        ],
        userBank: [
          { required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' },
        ],
        // bankservice: [
        //   { required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' },
        // ],
        amount: [
          { required: true, message: 'กรุณาระบุจำนวนเงิน', trigger: 'change' },
        ],
      },
      formOTP: {
        title: 'ระบบตรวจสอบ OTP',
        OTPCode: '',
      },
      rulesOTP: {
        OTPCode: [
          { required: true, message: 'กรุณากรอก OTP', trigger: 'change' },
          { min: 6, max: 6, message: 'OTP ต้องมีความยาว 6 ตัวอักษร', trigger: 'change' },
        ],
      },
      userBank: {
        icon: 'https://cdn.duckbet.com/wl/?id=iGPZ8yN6Vum7J2sYtrFYzJesTo6UZ7yt',
        bank: null,
        accountNumber: null,
        accountName: null,
      },
      forms: {
        bankId: null,
        accountNumber: null,
        depositPaymentId: null,
      },
      banks: [],
      bankId: null,
      confirmLoading: false,
      formRefund: {
        depositPaymentId: '',
        operator: '',
        title: '',
        bank: null,
        accountToDisplayName: null,
        bankServiceSystem: null,
        accountNumber: null,
        accountName: null,
        amount: '',
        bankServiceId: '',
        operatorCode: '',
        remark: null,
        slip: null,
      },
      rulesRefund: {
        operator: [
          { required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' },
        ],
        slip: [
          { required: true, message: 'กรุณาระบุสลิปหลักฐาน', trigger: 'change' },
        ],
        bankservice: [
          { required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' },
        ],
        amount: [
          { required: true, message: 'กรุณาระบุจำนวนเงิน', trigger: 'change' },
        ],
        remark: [
          { required: true, message: 'กรุณาระบุ' },
        ],
      },
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
    sendDataTable: function() {
      return {
        isReload: this.reloadTable,
      }
    },
  },
  methods: {
    async getDataOprator() {
      await apiClient.get('/system/getOperator').then(res => {
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getOperator = setData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error}`,
        )
      // this.visible = !this.visible
      })
    },
    async setOperator(value, option) {
      this.form.operatorCode = this.getOperator[option.key].operatorCode
      this.loading(true)
      await apiClient.get(`/system/getUsersBank/${this.form.operatorCode}`).then(res => {
        this.loading(false)
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getUserBank = setData.data
          this.getBankService = null
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async setOperatorBank(value, option) {
      this.formRefund.operatorCode = this.getOperator[option.key].operatorCode
      this.loading(true)
      await apiClient.get(`/system/getBankServiceRefund/${this.formRefund.operatorCode}/3/${this.bankId}`).then(res => {
        this.loading(false)
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getUserBankRefund = setData.data
          this.getBankServiceRefund = null
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },

    clearForm() {
      this.forms = {
        bankId: null,
        accountNumber: null,
        depositPaymentId: null,
      }
    },
    setUserBank(value, option) {
      this.form.userBankId = this.getUserBank[option.key].userBankId
      this.loading(true)
      apiClient.get(`/system/getBankService/${this.form.operatorCode}/3/${this.form.userBankId}`).then(res => {
        this.loading(false)
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getBankService = setData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
         `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    setBankService(value, option) {
      this.form.bankServiceId = this.getBankService[option.key].bankServiceId
    },
    setBankServiceRefund(value, option) {
      this.formRefund.bankServiceId = this.getUserBankRefund[option.key].bankServiceId
    },
    async getFormRefun() {
    // check OTP Code type Refun
      this.loading(true)
      const checkDupelicate = await apiClient.post('/checkOTP/checkDuplicate', { type: 1 }).then(res => {
        this.loading(false)
        if (res.data.code === '000') {
          const setData = res.data.responseData
          return setData
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })

      if (checkDupelicate.data) {
        this.modalOTPClose()
      } else {
        this.form.title = 'เพิ่มรายการโอนเงินคืนลูกค้า'
        this.getDataOprator()
        this.handleCancel()
      }
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
    handleOk(e) {
    // console.log(this.$refs);
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading(true)
          const sentData = {
            operatorCode: this.form.operatorCode,
            bankServiceId: this.form.bankServiceId,
            userBankId: this.form.userBankId,
            amount: this.form.amount,
          }
          // insert OTP
          apiClient.post('/withdraw/refund', sentData).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            if (res.code === '000') {
              this.visible = !this.visible
              this.visibleOTP = !this.visibleOTP
              this.$refs.ruleForm.resetFields()
            }
          }).catch(error => {
            Swal.showValidationMessage(
                          `เกิดข้อผิดพลาด: ${error.message}`,
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.visible = !this.visible
      this.form = {
        title: '',
        operator: '',
        userBank: '',
        bankservice: '',
        amount: '',
        operatorCode: '',
        bankServiceId: '',
        userBankId: '',
      }
      this.getOperator = []
      this.getUserBank = null
      this.getBankService = null
    },
    modalOTPClose() {
      this.visibleOTP = !this.visibleOTP
      this.formOTP = {
        title: 'ระบบตรวจสอบ OTP',
        OTPCode: '',
      }
    },
    modalCheckBankClose() {
      this.visibleCheckBank = !this.visibleCheckBank
      this.clearForm()
    },
    isReloadTable() {
      this.reloadTable = !this.reloadTable
    },
    isReloadData() {
      if (!this.reloadData) {
        this.getDataBankSum()
      }
    },
    resendOTP() {
      Swal.fire({
        icon: 'info',
        title: 'แน่ใจหรือไม่ที่ต้องการส่ง OTP อีกครั้ง',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.post('checkOTP/reSentOTP', { type: 1 }).then(response => {
              if (response.status !== 200) throw new Error(response.message)
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                              `เกิดข้อผิดพลาด: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.isReloadTable()
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
        }
      })
    },
    cancelOTP() {
      Swal.fire({
        icon: 'info',
        title: 'แน่ใจหรือไม่ที่จะยกเลิกรายการ',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            return apiClient.post('checkOTP/cancelOTP', { type: 1 }).then(response => {
            // console.log(response);
              if (response.status !== 200) throw new Error(response.message)
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                              `เกิดข้อผิดพลาด: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
      // console.log(result);
      /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          if (result.value.code === '000') {
            this.isReloadTable()
            this.modalOTPClose()
            this.getFormRefun()
          }
        }
      })
    },
    sentOTP() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Swal.fire({
            icon: 'info',
            title: 'แน่ใจหรือไม่ที่ต้องการส่งข้อมูล',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                const sentData = {
                  type: 1,
                  OTPCode: this.formOTP.OTPCode,
                }

                return apiClient.post('checkOTP/sentOTP', sentData).then(response => {
                  if (response.status !== 200) throw new Error(response.message)
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                                      `เกิดข้อผิดพลาด: ${error}`,
                  )
                })
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              if (result.value.code === '000') {
                this.modalOTPClose()
                this.isReloadTable()
              }
            }
          })
        }
      })
    },
    PreviewImg(img) {
      if (img !== '') {
        return img
      } else {
        return 'No Image'
      }
    },
    async getDataBankSum() {
      await apiClient.post('/withdraw/getDataBankSumRefund').then(res => {
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.getBankSum = setData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async handleSubmit() {
      this.bankId = this.forms.bankId
      this.confirmLoading = true
      await apiClient.post('/users/checkBank', this.forms).then(response => {
        const res = response.data
        const iconError = (res.code === '000') ? 'success' : 'error'
        Toast.fire({ icon: iconError, title: res.message })
        if (res.code === '000') {
          const dataUserBank = res.responseData.data
          // this.formRefund = {
          //   title: 'ฟอร์มคืนเงินลูกค้า',
          //   accountToDisplayName: dataUserBank.accountToDisplayName,
          //   bank: dataUserBank.bankName,
          //   accountNumber: dataUserBank.accountNumber,
          //   accountName: dataUserBank.accountToName,
          // }
          this.getBankPayment(this.forms.depositPaymentId, dataUserBank)
          this.getDataOprator()
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getBankPayment(depositPaymentId, dataUserBank) {
      this.clearFormRefund()
      this.confirmLoading = false
      apiClient.get(`/withdraw/getBankPayment/${depositPaymentId}`).then(response => {
        const res = response.data
        const iconError = (res.code === '000') ? 'success' : 'error'
        Toast.fire({ icon: iconError, title: res.message })
        if (res.code === '000') {
          const data = res.responseData.data[0]
          this.visibleCheckBank = !this.visibleCheckBank
          this.formRefund = {
            depositPaymentId: depositPaymentId,
            operator: data.name,
            title: 'ฟอร์มคืนเงินลูกค้า',
            accountToDisplayName: dataUserBank.accountToDisplayName,
            bank: dataUserBank.bankName,
            accountNumber: dataUserBank.accountNumber,
            accountName: dataUserBank.accountToName,
            amount: data.amount,
            bankservice: data.bankservice,
            bankServiceId: data.bankServiceId,
            bankServiceSystem: data.bankServiceSystem,
            operatorCode: data.operatorCode,
            remark: null,
            slip: null,
          }
          this.visibleFormRefund = true
        } else {
          this.resetUserBank()
        }
        this.clearForm()
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    resetUserBank() {
      this.userBank = {
        icon: 'https://cdn.duckbet.com/wl/?id=iGPZ8yN6Vum7J2sYtrFYzJesTo6UZ7yt',
        bank: null,
        accountNumber: null,
        accountName: null,
      }
    },

    handleOkFormRefund(e) {
      this.$refs.ruleFormRefund.validate(valid => {
        if (valid) {
          this.loading(true)
          const sentData = {
            depositPaymentId: this.formRefund.depositPaymentId,
            operatorCode: this.formRefund.operatorCode,
            bankServiceId: this.formRefund.bankServiceId,
            bankId: this.bankId,
            accountNumber: this.formRefund.accountNumber,
            accountNameToBank: this.formRefund.accountToDisplayName,
            accountNameToBankEng: this.formRefund.accountName,
            amount: this.formRefund.amount,
            remark: this.formRefund.remark,
            slip: this.formRefund.slip,
          }
          // insert OTP
          // console.log(sentData, 88997)
          apiClient.post('/withdraw/refundUpdate', sentData).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            if (res.code === '000') {
              this.$refs.ruleFormRefund.resetFields()
              this.isReloadTable()
            }
            this.visibleFormRefund = !this.visibleFormRefund
          }).catch(error => {
            Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
            )
          })
        } else {
          return false
        }
      })
    },
    clearFormRefund() {
      this.formRefund = {
        depositPaymentId: null,
        operator: null,
        title: null,
        accountToDisplayName: null,
        bank: null,
        accountNumber: null,
        accountName: null,
        amount: null,
        bankservice: null,
        bankServiceId: null,
        bankServiceSystem: null,
        operatorCode: null,
        remark: null,
        slip: null,
      }
    },
    handleCancelFormRefund() {},

    async getDataRefund() {
      this.visibleCheckBank = true
      await apiClient.get('/system/getBank').then(response => {
        const res = response.data
        if (res.code === '000') {
          this.banks = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
        `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },

  },
  async created() {
    await this.getDataBankSum()
  // await this.getDataDeposit()
  },
}
</script>

<style>

</style>
